<template>
  <div class="select_box icon_font dropdown" :class="{open: isOpen}">
    <button type="button" class="selected" @click="toggle">
      {{ codeName }}
    </button>
    <ul class="option">
      <li v-for="(item, i) in props.option" :key="`${item.comCd}_${item.codeName}_${i}`">
        <button type="button" @click.prevent="selectOption(item.comCd)">
          {{ item.codeName }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">

interface Option {
  comCd: string
  codeName: string
}
const props = defineProps<{ option: Option[], value: '' }>()
const model = reactive<{ value: string }>({ value: props.value })
const emit = defineEmits<{(e: 'select:option', select: string): void }>()

const isOpen = ref<boolean>(false)

onMounted(() => {
  // 외부 클릭시 닫힘 이벤트 등록
  document.addEventListener('click', clickOutside)
})

onUnmounted(() => {
  // 외부 클릭시 닫힘 이벤트 제거
  document.removeEventListener('click', clickOutside)
})
/* 외부 클릭시 닫힘 */
const clickOutside = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (isOpen.value) {
    if (!target.closest('.select_box')) {
      toggle()
    }
  }
}

const codeName = computed(() => {
  const findIndex = props.option.findIndex(item => item.comCd === model.value)
  if (findIndex === -1) { return props.option[0].codeName }
  return props.option[findIndex].codeName
})

const selectOption = (select: string) => {
  if (select !== model.value) {
    emit('select:option', select)
    model.value = select
  }
  isOpen.value = false
}

const toggle = () => {
  isOpen.value = !isOpen.value
}
const setData = (value: string) => {
  model.value = value
}

defineExpose({ setData })

</script>

<style scoped>
.select_box{display:inline-block; position:relative;}
.select_box:before{content: "\e014"; display:block; position:absolute; right:5px; top:8px; color: var(--color-sorting-default); transform: rotate(180deg); font-size:9.6px;}
.select_box .selected{position:relative; z-index:1; display:inline-block; min-width:92px; padding:0 24px 0 12px; color: var(--color-sorting-default); font-size:var(--font-size-7); line-height:1.625rem; height:1.75rem; box-sizing:border-box; background:transparent; text-align:left;}
.select_box .option{display:none; position:absolute; right:0; top:1.6875rem; min-width: -webkit-fill-available; width:max-content; background:var(--color-background-default); z-index:100; border:1px solid var(--color-line); border-radius:4px; box-sizing: border-box; overflow: hidden;}
.select_box .option button{display:block; width:100%; font-size: var(--font-size-7); line-height:1.75rem; color:var(--color-sorting-default); padding:0 12px; background:transparent; border:none; box-sizing:border-box; text-align:left; word-break: break-word;}
.select_box .option button:hover{background:var(--color-sorting-hover);}
.select_box.open .option{display:block;}
.select_box.open:after{transform: rotate(180deg);}
.select_box.ty2:before{right:9px;}
.select_box.ty2:after{content: ""; display:block; position:absolute; right:27px; top:0; height:100%; width:1px; background:var(--color-line)}
.select_box.ty2 .selected{border:1px solid var(--color-line); border-radius:4px; padding:0 39px 0 11px;}
</style>
